import * as actionTypes from '../utils/constants';

const initialState = {};
const buildingsReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.GET_BUILDINGS: {
      const newState = {
        ...state,
      };
      newState.buildingsReducer = action.action;
      return newState;
    }
    default: {
      return state;
    }
  }
};

export default buildingsReducer;
